import { render, staticRenderFns } from "./Dispensacao.vue?vue&type=template&id=6192f776&"
import script from "./Dispensacao.vue?vue&type=script&lang=js&"
export * from "./Dispensacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports